import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TextField from "@mui/material/TextField";
import { ThemeProvider } from '@mui/styles';
import Clipboard from "react-clipboard.js";
import dayjs from 'dayjs';
import React, { Component } from 'react';
import NumberFormat from 'react-number-format';
import { Link } from 'react-router-dom';
import Select from "react-select";
import CircularLoading from "../components/CircularLoading";
import { GetToken, GuestLogin, Me, RefreshSession, SetToken, SetUser, GetUser } from "../services/Session";
import { GetXlsxAffiliateOrder, GetXlsxAffiliateSummary,  GetAffiliateOrder, GetAffiliateSummary, SetAffiliateSettlement } from '../services/Transaction';
import '../styles/style.css';
import theme from '../styles/theme';

const BackIcon = '/assets/svg/back.svg'
const FilterIcon = "/assets/svg/filter.svg";

class Affiliate extends Component {
	constructor(props) {
		super(props);
		this.state = {
			tabPosition: "1",
			isOpenFilter: false,
			isOpenSettlement: false,
			isLoading: false,
			settlementReferralCode: "",
			raw_type_filter: [],
			raw_status_filter: [{ value: "open", label: "Open" }],
			referral_status: 'open',
			filters: {
				'referral_code.$ne': 'null',
			},
			summaries: [],
			leads: [],
			losts: [],
			closings: [],
			settleds: [],
		};
	}

	componentDidMount = () => {
		this.handleGetAffiliateSummary()
	}

	handleGetAffiliateSummary = () => {
		GetAffiliateSummary({'referral_status.$in': this.state.referral_status, sorts: '-amount', ...this.state.filters}).then(res => {
			this.setState({ summaries: res.data.results })
		}).catch(err => {
			if (err.response) {
				if (err.response && err.response.status === 401) {
					if (GetToken().refresh_token !== null) {
						RefreshSession(GetToken().refresh_token)
					} else {
						this.handleLogout()
					}
				}
			}
		})
	}

	handleGetAffiliateLead = () => {
		GetAffiliateOrder({status: 'awaiting_payment', sorts: '-expired_at', ...this.state.filters}).then(res => {
			this.setState({ leads: res.data.results })
		}).catch(err => {
			if (err.response) {
				if (err.response && err.response.status === 401) {
					if (GetToken().refresh_token !== null) {
						RefreshSession(GetToken().refresh_token)
					} else {
						this.handleLogout()
					}
				}
			}
		})
	}

	handleGetAffiliateLost = () => {
		GetAffiliateOrder({'status.$in': 'expired,canceled', sorts: '-expired_at', ...this.state.filters}).then(res => {
			this.setState({ losts: res.data.results })
		}).catch(err => {
			if (err.response) {
				if (err.response && err.response.status === 401) {
					if (GetToken().refresh_token !== null) {
						RefreshSession(GetToken().refresh_token)
					} else {
						this.handleLogout()
					}
				}
			}
		})
	}

	handleGetAffiliateClosing = () => {
		GetAffiliateOrder({'status.$in': 'paid,packing,shipped,delivered', 'referral_status': 'open', sorts: '-date', ...this.state.filters}).then(res => {
			this.setState({ closings: res.data.results })
		}).catch(err => {
			if (err.response) {
				if (err.response && err.response.status === 401) {
					if (GetToken().refresh_token !== null) {
						RefreshSession(GetToken().refresh_token)
					} else {
						this.handleLogout()
					}
				}
			}
		})
	}

	handleGetAffiliateSettled = () => {
		GetAffiliateOrder({'status.$in': 'paid,packing,shipped,delivered', 'referral_status': 'settled', sorts: '-referral_settled_at,referral_code', ...this.state.filters}).then(res => {
			this.setState({ settleds: res.data.results })
		}).catch(err => {
			if (err.response) {
				if (err.response && err.response.status === 401) {
					if (GetToken().refresh_token !== null) {
						RefreshSession(GetToken().refresh_token)
					} else {
						this.handleLogout()
					}
				}
			}
		})
	}

	handleSettlement = () => {
		SetAffiliateSettlement(this.state.settlementReferralCode).then(res => {
			alert('Affiliate with referral code '+this.state.settlementReferralCode+' has been settled!')
			this.handleGetAffiliateSummary();
		}).catch(err => {
			if (err.response) {
				if (err.response && err.response.status === 401) {
					if (GetToken().refresh_token !== null) {
						RefreshSession(GetToken().refresh_token)
					} else {
						this.handleLogout()
					}
				}
			}
		})
		this.setState({isOpenSettlement: false, settlementReferralCode: ''})
	}

	handleDownloadAffiliateSummary = () => {
		this.setState({ isLoading: true })
		GetXlsxAffiliateSummary({'referral_status.$in': this.state.referral_status, sorts: '-amount', ...this.state.filters}).then(res => {
			this.setState({ isLoading: false })
			const downloadUrl = window.URL.createObjectURL(new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }));
			const link = document.createElement('a');
			link.href = downloadUrl;
			link.setAttribute('download', 'affiliate-summary-settled-' + dayjs().format('YYYY-MM-DD_HH.mm') + '.xlsx'); // todo : change to pdf when be is done
			document.body.appendChild(link);
			link.click();
			link.remove();
		}).catch(err => {
			this.setState({ isLoading: false })
			if (err.response) {
				if (err.response && err.response.status === 401) {
					if (GetToken().refresh_token !== null) {
						RefreshSession(GetToken().refresh_token)
					} else {
						this.handleLogout()
					}
				}
			}
		})
	}

	handleDownloadAffiliateLead = () => {
		this.setState({ isLoading: true })
		GetXlsxAffiliateOrder({status: 'awaiting_payment', sorts: '-expired_at', ...this.state.filters}).then(res => {
			this.setState({ isLoading: false })
			const downloadUrl = window.URL.createObjectURL(new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }));
			const link = document.createElement('a');
			link.href = downloadUrl;
			link.setAttribute('download', 'affiliate-order-lead-' + dayjs().format('YYYY-MM-DD_HH.mm') + '.xlsx'); // todo : change to pdf when be is done
			document.body.appendChild(link);
			link.click();
			link.remove();
		}).catch(err => {
			this.setState({ isLoading: false })
			if (err.response) {
				if (err.response && err.response.status === 401) {
					if (GetToken().refresh_token !== null) {
						RefreshSession(GetToken().refresh_token)
					} else {
						this.handleLogout()
					}
				}
			}
		})
	}

	handleDownloadAffiliateLost = () => {
		this.setState({ isLoading: true })
		GetXlsxAffiliateOrder({'status.$in': 'expired,canceled', sorts: '-expired_at', ...this.state.filters}).then(res => {
			this.setState({ isLoading: false })
			const downloadUrl = window.URL.createObjectURL(new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }));
			const link = document.createElement('a');
			link.href = downloadUrl;
			link.setAttribute('download', 'affiliate-order-lost-' + dayjs().format('YYYY-MM-DD_HH.mm') + '.xlsx'); // todo : change to pdf when be is done
			document.body.appendChild(link);
			link.click();
			link.remove();
		}).catch(err => {
			this.setState({ isLoading: false })
			if (err.response) {
				if (err.response && err.response.status === 401) {
					if (GetToken().refresh_token !== null) {
						RefreshSession(GetToken().refresh_token)
					} else {
						this.handleLogout()
					}
				}
			}
		})
	}

	handleDownloadAffiliateClosing = () => {
		this.setState({ isLoading: true })
		GetXlsxAffiliateOrder({'status.$in': 'paid,packing,shipped,delivered', 'referral_status': 'open', sorts: '-date', ...this.state.filters}).then(res => {
			this.setState({ isLoading: false })
			const downloadUrl = window.URL.createObjectURL(new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }));
			const link = document.createElement('a');
			link.href = downloadUrl;
			link.setAttribute('download', 'affiliate-order-closing-' + dayjs().format('YYYY-MM-DD_HH.mm') + '.xlsx'); // todo : change to pdf when be is done
			document.body.appendChild(link);
			link.click();
			link.remove();
		}).catch(err => {
			this.setState({ isLoading: false })
			if (err.response) {
				if (err.response && err.response.status === 401) {
					if (GetToken().refresh_token !== null) {
						RefreshSession(GetToken().refresh_token)
					} else {
						this.handleLogout()
					}
				}
			}
		})
	}

	handleDownloadAffiliateSettled = () => {
		this.setState({ isLoading: true })
		GetXlsxAffiliateOrder({'status.$in': 'paid,packing,shipped,delivered', 'referral_status': 'settled', sorts: '-referral_settled_at,referral_code', ...this.state.filters}).then(res => {
			this.setState({ isLoading: false })
			const downloadUrl = window.URL.createObjectURL(new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }));
			const link = document.createElement('a');
			link.href = downloadUrl;
			link.setAttribute('download', 'affiliate-order-settled-' + dayjs().format('YYYY-MM-DD_HH.mm') + '.xlsx'); // todo : change to pdf when be is done
			document.body.appendChild(link);
			link.click();
			link.remove();
		}).catch(err => {
			this.setState({ isLoading: false })
			if (err.response) {
				if (err.response && err.response.status === 401) {
					if (GetToken().refresh_token !== null) {
						RefreshSession(GetToken().refresh_token)
					} else {
						this.handleLogout()
					}
				}
			}
		})
	}


	handleLogout = () => {
		GuestLogin().then(res => {
			Me(SetToken(res.data.token).access_token).then(res => {
				SetUser(res.data);
				setTimeout(this.props.history.push("/"), 3000);
			});
		});
	};

	openFilter = () => {
		this.setState({ isOpenFilter: true });
	};

	closeFilter = () => {
		this.setState({ isOpenFilter: false });
	};

	resetFilter = () => {
		this.setState({
			tabPosition: "1",
			raw_type_filter: [],
			raw_status_filter: [{ value: "open", label: "Open" }],
			referral_status: 'open',
			filters: {
				'referral_code.$ne': 'null',
			},
		});
	};

	applyFilter = () => {
		this.setState({
			isOpenFilter: false
		});

		if (this.state.tabPosition=="1") {
			this.handleGetAffiliateSummary()
		} else if (this.state.tabPosition=="2") {
			this.handleGetAffiliateLead()
		} else if (this.state.tabPosition=="3") {
			this.handleGetAffiliateLost()
		} else if (this.state.tabPosition=="4") {
			this.handleGetAffiliateClosing()
		} else if (this.state.tabPosition=="5") {
			this.handleGetAffiliateSettled()
		}
	}

	handleChangeTab = (event, val) => {
		if (val=="1") {
			this.handleGetAffiliateSummary()
		} else if (val=="2") {
			this.handleGetAffiliateLead()
		} else if (val=="3") {
			this.handleGetAffiliateLost()
		} else if (val=="4") {
			this.handleGetAffiliateClosing()
		} else if (val=="5") {
			this.handleGetAffiliateSettled()
		}
		this.setState({ tabPosition: val });
	};

	handleChangeFilterOption = (selectedOptions, filtername) => {
		if (filtername === 'referral_status') {
			const selected = selectedOptions ? selectedOptions.map(opt => opt.value) : [];
			this.setState({
				raw_status_filter: selectedOptions,
				referral_status: selected.toString(),
			})
		} else if (filtername === 'expired_at.$gte' || filtername === 'expired_at.$lt' || filtername === 'date.$gte' || filtername === 'date.$lt') {
			const fValue = (filtername === 'expired_at.$gte' || filtername === 'date.$gte') ? selectedOptions.target.value : dayjs(selectedOptions.target.value).add(1, 'days').format('YYYY-MM-DD');
			this.setState({
				[filtername]: selectedOptions.target.value,
				filters: {
					...this.state.filters,
					[filtername]: fValue,
				}
			})
		} else if (filtername === 'sort') {
			this.setState({
				raw_sort_filter: selectedOptions,
				filters: {
					...this.state.filters,
					sorts: selectedOptions.value
				}
			})
		} else {
			this.setState({
				[filtername]: selectedOptions.target.value,
				filters: {
					...this.state.filters,
					[filtername]: '%' + selectedOptions.target.value + '%',
				}
			})
		}
	}

	filterDialog = () => {
		const selectStyles = { menu: styles => ({ ...styles, zIndex: 999 }) }
		return (
			<Dialog
				open={this.state.isOpenFilter}
				onClose={this.closeFilter}
				aria-labelledby="form-dialog-title"
				className="dialog-filter"
				style={{ height: "100%" }}
			>
				<DialogTitle id="form-dialog-title">Filter</DialogTitle>
				<DialogContent>
					<div
						className="center"
						style={{ width: 240, paddingTop: 10, paddingBottom: 10, fontFamily: 'Open Sans' }}
					>
						<Select
							styles={selectStyles}
							isMulti
							placeholder="Status"
							isSearchable={true}
							value={this.state.raw_status_filter}
							onChange={(opt) => this.handleChangeFilterOption(opt, 'referral_status')}
							options={[
								{ value: "open", label: "Open" },
								{ value: "settled", label: "Settled" },
							]}
						/>
					</div>
					<div className="center" style={{ width: 240, paddingTop: 0, paddingBottom: 10, fontFamily: 'Open Sans' }}>
						<TextField
							label="Referral Code"
							defaultValue={this.state['referral_code.$ilike']}
							onChange={(opt) => this.handleChangeFilterOption(opt, 'referral_code.$ilike')}
							size="small"
							variant="outlined"
							style={{ height: 40, width: 240, paddingTop: 0, paddingBottom: 20, marginBottom: 10 }}
						/>
						<TextField
							label="Order Number"
							defaultValue={this.state['number.$ilike']}
							onChange={(opt) => this.handleChangeFilterOption(opt, 'number.$ilike')}
							size="small"
							variant="outlined"
							style={{ height: 40, width: 240, paddingTop: 0, paddingBottom: 20, marginBottom: 10 }}
						/>
						<TextField
							label="Customer Name"
							defaultValue={this.state['customer.name.$ilike']}
							onChange={(opt) => this.handleChangeFilterOption(opt, 'customer.name.$ilike')}
							size="small"
							variant="outlined"
							style={{ height: 40, width: 240, paddingTop: 0, paddingBottom: 20, marginBottom: 10 }}
						/>
						<TextField
							label="Phone"
							defaultValue={this.state['customer.phone.$ilike']}
							onChange={(opt) => this.handleChangeFilterOption(opt, 'customer.phone.$ilike')}
							size="small"
							variant="outlined"
							style={{ height: 40, width: 240, paddingTop: 0, paddingBottom: 20, marginBottom: 10 }}
						/>
						<TextField
							label="Email"
							defaultValue={this.state['customer.email.$ilike']}
							onChange={(opt) => this.handleChangeFilterOption(opt, 'customer.email.$ilike')}
							size="small"
							variant="outlined"
							style={{ height: 40, width: 240, paddingTop: 0, paddingBottom: 20 }}
						/>
					</div>
					<div className="center" style={{ width: 240, paddingTop: 0, paddingBottom: 10, fontFamily: 'Open Sans' }}>
						<div style={{ paddingBottom: 10 }}>Expired Date</div>
						<TextField
							label="From"
							type="date"
							defaultValue={this.state['expired_at.$gte']}
							onChange={(opt) => this.handleChangeFilterOption(opt, 'expired_at.$gte')}
							size="small"
							variant="outlined"
							style={{ height: 40, width: 240, paddingTop: 0, paddingBottom: 10, marginBottom: 10 }}
							InputLabelProps={{
								shrink: true,
							}}
						/>
						<TextField
							label="To"
							type="date"
							defaultValue={this.state['expired_at.$lt']}
							onChange={(opt) => this.handleChangeFilterOption(opt, 'expired_at.$lt')}
							size="small"
							variant="outlined"
							style={{ height: 40, width: 240, paddingTop: 0, paddingBottom: 10 }}
							InputLabelProps={{
								shrink: true,
							}}
						/>
						<div style={{ paddingTop: 10, paddingBottom: 10 }}>Payment Date</div>
						<TextField
							label="From"
							type="date"
							defaultValue={this.state['date.$gte']}
							onChange={(opt) => this.handleChangeFilterOption(opt, 'date.$gte')}
							size="small"
							variant="outlined"
							style={{ height: 40, width: 240, paddingTop: 0, paddingBottom: 10, marginBottom: 10 }}
							InputLabelProps={{
								shrink: true,
							}}
						/>
						<TextField
							label="To"
							type="date"
							defaultValue={this.state['date.$lt']}
							onChange={(opt) => this.handleChangeFilterOption(opt, 'date.$lt')}
							size="small"
							variant="outlined"
							style={{ height: 40, width: 240, paddingTop: 0, paddingBottom: 10 }}
							InputLabelProps={{
								shrink: true,
							}}
						/>
					</div>
					<div
						className="center"
						style={{ width: 240, paddingTop: 0, paddingBottom: 100, fontFamily: 'Open Sans' }}
					>
						<Select
							styles={selectStyles}
							placeholder="Sort by"
							value={this.state.raw_sort_filter}
							onChange={(opt) => this.handleChangeFilterOption(opt, 'sort')}
							options={[
								{ value: "-created_at", label: "Newest" },
								{ value: "created_at", label: "Oldest" },
							]}
						/>
					</div>
				</DialogContent>
				<DialogActions>
					<Button onClick={this.resetFilter} color="primary">
						Atur Ulang
					</Button>
					<Button onClick={this.applyFilter} color="primary">
						Terapkan
					</Button>
				</DialogActions>
			</Dialog>
		);
	};

	render() {
		let summary_amount = 0;
		let lead_amount = 0;
		let lost_amount = 0;
		let closing_amount = 0;
		let user = GetUser();
		let referralURL = window.location.origin+'?ref='+user.nip;

		return (
			<ThemeProvider theme={theme}>
				<div style={{ position: 'relative', maxWidth: '60rem', margin: 'auto' }}>
					<div className="header">
						<Link to="/" style={{ position: "absolute", height: 60, width: 60, top: 0, left: 0 }}>
							<img alt="icon" src={BackIcon} />
						</Link>
						<div className="center" style={{ marginTop: 20 }}>
							<h3 className="title">Affiliate</h3>
						</div>
						<div style={{ position: "absolute", height: 24, width: 60, top: 18, right: 10, cursor: 'pointer' }}>
							<img alt="icon" src={FilterIcon} onClick={this.openFilter} />
						</div>
					</div>
					<div className="wrapper">
						{this.filterDialog()}
						<Dialog open={this.state.isOpenSettlement} onClose={() => this.setState({isOpenSettlement: !this.state.isOpenSettlement})} aria-labelledby="form-dialog-title">
							<DialogTitle id="form-dialog-title">Konfirmasi</DialogTitle>
							<DialogContent>
								<DialogContentText>Apakah komisi atas kode referral {this.state.settlementReferralCode} sudah dibayar?</DialogContentText>
							</DialogContent>
							<DialogActions>
								<Button variant="outlined" onClick={() => this.setState({isOpenSettlement: !this.state.isOpenSettlement})} color="secondary">Tidak</Button>
								<Button variant="contained" onClick={() => this.handleSettlement()} color="secondary">Ya</Button>
							</DialogActions>
						</Dialog>
						<div style={{ padding: 10 }}>
							<div>Your Referral Code : {user.nip} 
								<span style={{ marginLeft: 10, cursor: 'pointer' }}>
									<Clipboard component="span" onSuccess={() => alert('Coppied')} data-clipboard-text={user.nip}>
										<img alt="icon" src="/assets/svg/copy.svg" />
									</Clipboard>
								</span>
								<a target="_blank" rel="noopener noreferrer" href={"https://api.whatsapp.com/send?text=" + encodeURI(referralURL)} style={{ textDecoration: "none", height: 60, width: 60 }}><img alt="icon" src="/assets/svg/share.svg" /></a>
							</div>
							<Box sx={{ width: '100%', typography: 'body1' }}>
								<TabContext value={this.state.tabPosition}>
									<Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
										<TabList onChange={this.handleChangeTab} aria-label="lab API tabs example">
											<Tab label="Summary" value="1" />
											<Tab label="Lead" value="2" />
											<Tab label="Lost" value="3" />
											<Tab label="Closing" value="4" />
											<Tab label="Settled" value="5" />
										</TabList>
									</Box>
									<TabPanel value="1">
										<div style={{ paddingBottom: 10, textAlign: 'right'}}>{this.state.IsLoading ? <CircularLoading size={20} /> : <div style={{cursor: 'pointer'}} onClick={this.handleDownloadAffiliateSummary}><img alt="icon" src="/assets/svg/document.svg" /></div>}</div>
										<TableContainer component={Paper}>
											<Table>
												<TableHead>
													<TableRow>
														<TableCell>Referral Code</TableCell>
														<TableCell>Name</TableCell>
														<TableCell>Phone</TableCell>
														<TableCell>Email</TableCell>
														<TableCell align="right">Sales Count</TableCell>
														<TableCell align="right">Sales Amount</TableCell>
														<TableCell></TableCell>
													</TableRow>
												</TableHead>
												<TableBody>
													{(this.state.summaries && this.state.summaries.length > 0) && this.state.summaries.map((trx, index) => {
														summary_amount += trx?.sales_amount;
														return (
															<TableRow key={index}>
																<TableCell>{trx?.referral_code}</TableCell>
																<TableCell>{trx?.name}</TableCell>
																<TableCell>{trx?.phone}</TableCell>
																<TableCell>{trx?.email}</TableCell>
																<TableCell align="right"><NumberFormat value={trx.sales_count} displayType={'text'} thousandSeparator={'.'} decimalSeparator={','} /></TableCell>
																<TableCell align="right"><NumberFormat value={trx.sales_amount} displayType={'text'} thousandSeparator={'.'} decimalSeparator={','} /></TableCell>
																<TableCell>
																	{user?.role?.id > 2 && <div style={{cursor: 'pointer'}} onClick={() => this.setState({isOpenSettlement: true, settlementReferralCode: trx.referral_code})}><img alt="icon" src="/assets/svg/currency-exchange.svg" /></div>}
																</TableCell>
															</TableRow>
														)
													})}
													<TableRow>
														<TableCell><b>Total</b></TableCell>
														<TableCell></TableCell>
														<TableCell></TableCell>
														<TableCell></TableCell>
														<TableCell></TableCell>
														<TableCell align="right"><b><NumberFormat value={summary_amount} displayType={'text'} thousandSeparator={'.'} decimalSeparator={','} /></b></TableCell>
														<TableCell></TableCell>
													</TableRow>
												</TableBody>
											</Table>
										</TableContainer>
									</TabPanel>
									<TabPanel value="2">
										<div style={{ paddingBottom: 10, textAlign: 'right'}}>{this.state.IsLoading ? <CircularLoading size={20} /> : <div style={{cursor: 'pointer'}} onClick={this.handleDownloadAffiliateLead}><img alt="icon" src="/assets/svg/document.svg" /></div>}</div>
										<TableContainer component={Paper}>
											<Table>
												<TableHead>
													<TableRow>
														<TableCell>Referral Code</TableCell>
														<TableCell>Customer</TableCell>
														<TableCell>Phone</TableCell>
														<TableCell>Number</TableCell>
														<TableCell>Expired At</TableCell>
														<TableCell align="right">Sales Amount</TableCell>
													</TableRow>
												</TableHead>
												<TableBody>
													{(this.state.leads && this.state.leads.length > 0) && this.state.leads.map((trx, index) => {
														let amount = trx?.amount-trx?.delivery_cost
														lead_amount += amount;
														return (
															<TableRow key={index}>
																<TableCell>{trx?.referral_code}</TableCell>
																<TableCell>{trx?.customer?.name}</TableCell>
																<TableCell>{trx?.customer?.phone}</TableCell>
																<TableCell>{trx?.number}</TableCell>
																<TableCell>{dayjs(trx?.expired_at).format("D-MMM-YYYY HH:mm")}</TableCell>
																<TableCell align="right"><NumberFormat value={amount} displayType={'text'} thousandSeparator={'.'} decimalSeparator={','} /></TableCell>
															</TableRow>
														)
													})}
													<TableRow>
														<TableCell><b>Total</b></TableCell>
														<TableCell></TableCell>
														<TableCell></TableCell>
														<TableCell></TableCell>
														<TableCell></TableCell>
														<TableCell align="right"><b><NumberFormat value={lead_amount} displayType={'text'} thousandSeparator={'.'} decimalSeparator={','} /></b></TableCell>
													</TableRow>
												</TableBody>
											</Table>
										</TableContainer>
									</TabPanel>
									<TabPanel value="3">
										<div style={{ paddingBottom: 10, textAlign: 'right'}}>{this.state.IsLoading ? <CircularLoading size={20} /> : <div style={{cursor: 'pointer'}} onClick={this.handleDownloadAffiliateLost}><img alt="icon" src="/assets/svg/document.svg" /></div>}</div>
										<TableContainer component={Paper}>
											<Table>
												<TableHead>
													<TableRow>
														<TableCell>Referral Code</TableCell>
														<TableCell>Customer</TableCell>
														<TableCell>Phone</TableCell>
														<TableCell>Number</TableCell>
														<TableCell>Expired At</TableCell>
														<TableCell align="right">Sales Amount</TableCell>
													</TableRow>
												</TableHead>
												<TableBody>
													{(this.state.losts && this.state.losts.length > 0) && this.state.losts.map((trx, index) => {
														let amount = trx?.amount-trx?.delivery_cost
														lost_amount += amount;
														return (
															<TableRow key={index}>
																<TableCell>{trx?.referral_code}</TableCell>
																<TableCell>{trx?.customer?.name}</TableCell>
																<TableCell>{trx?.customer?.phone}</TableCell>
																<TableCell>{trx?.number}</TableCell>
																<TableCell>{dayjs(trx?.expired_at).format("D-MMM-YYYY HH:mm")}</TableCell>
																<TableCell align="right"><NumberFormat value={amount} displayType={'text'} thousandSeparator={'.'} decimalSeparator={','} /></TableCell>
															</TableRow>
														)
													})}
													<TableRow>
														<TableCell><b>Total</b></TableCell>
														<TableCell></TableCell>
														<TableCell></TableCell>
														<TableCell></TableCell>
														<TableCell></TableCell>
														<TableCell align="right"><b><NumberFormat value={lost_amount} displayType={'text'} thousandSeparator={'.'} decimalSeparator={','} /></b></TableCell>
													</TableRow>
												</TableBody>
											</Table>
										</TableContainer>
									</TabPanel>
									<TabPanel value="4">
										<div style={{ paddingBottom: 10, textAlign: 'right'}}>{this.state.IsLoading ? <CircularLoading size={20} /> : <div style={{cursor: 'pointer'}} onClick={this.handleDownloadAffiliateClosing}><img alt="icon" src="/assets/svg/document.svg" /></div>}</div>
										<TableContainer component={Paper}>
											<Table>
												<TableHead>
													<TableRow>
														<TableCell>Referral Code</TableCell>
														<TableCell>Customer</TableCell>
														<TableCell>Number</TableCell>
														<TableCell>Paid At</TableCell>
														<TableCell align="right">Sales Amount</TableCell>
													</TableRow>
												</TableHead>
												<TableBody>
													{(this.state.closings && this.state.closings.length > 0) && this.state.closings.map((trx, index) => {
														let amount = trx?.amount-trx?.delivery_cost
														closing_amount += amount;
														return (
															<TableRow key={index}>
																<TableCell>{trx?.referral_code}</TableCell>
																<TableCell>{trx?.customer?.name}</TableCell>
																<TableCell>{trx?.number}</TableCell>
																<TableCell>{dayjs(trx?.date).format("D-MMM-YYYY HH:mm")}</TableCell>
																<TableCell align="right"><NumberFormat value={amount} displayType={'text'} thousandSeparator={'.'} decimalSeparator={','} /></TableCell>
															</TableRow>
														)
													})}
													<TableRow>
														<TableCell><b>Total</b></TableCell>
														<TableCell></TableCell>
														<TableCell></TableCell>
														<TableCell></TableCell>
														<TableCell align="right"><b><NumberFormat value={closing_amount} displayType={'text'} thousandSeparator={'.'} decimalSeparator={','} /></b></TableCell>
													</TableRow>
												</TableBody>
											</Table>
										</TableContainer>
									</TabPanel>
									<TabPanel value="5">
										<div style={{ paddingBottom: 10, textAlign: 'right'}}>{this.state.IsLoading ? <CircularLoading size={20} /> : <div style={{cursor: 'pointer'}} onClick={this.handleDownloadAffiliateSettled}><img alt="icon" src="/assets/svg/document.svg" /></div>}</div>
										<TableContainer component={Paper}>
											<Table>
												<TableHead>
													<TableRow>
														<TableCell>Referral Code</TableCell>
														<TableCell>Customer</TableCell>
														<TableCell>Number</TableCell>
														<TableCell>Settled At</TableCell>
														<TableCell align="right">Sales Amount</TableCell>
													</TableRow>
												</TableHead>
												<TableBody>
													{(this.state.settleds && this.state.settleds.length > 0) && this.state.settleds.map((trx, index) => {
														let amount = trx?.amount-trx?.delivery_cost
														closing_amount += amount;
														return (
															<TableRow key={index}>
																<TableCell>{trx?.referral_code}</TableCell>
																<TableCell>{trx?.customer?.name}</TableCell>
																<TableCell>{trx?.number}</TableCell>
																<TableCell>{dayjs(trx?.referral_settled_at).format("D-MMM-YYYY HH:mm")}</TableCell>
																<TableCell align="right"><NumberFormat value={amount} displayType={'text'} thousandSeparator={'.'} decimalSeparator={','} /></TableCell>
															</TableRow>
														)
													})}
													<TableRow>
														<TableCell><b>Total</b></TableCell>
														<TableCell></TableCell>
														<TableCell></TableCell>
														<TableCell></TableCell>
														<TableCell align="right"><b><NumberFormat value={closing_amount} displayType={'text'} thousandSeparator={'.'} decimalSeparator={','} /></b></TableCell>
													</TableRow>
												</TableBody>
											</Table>
										</TableContainer>
									</TabPanel>
								</TabContext>
							</Box>
						</div>
					</div>
				</div>
			</ThemeProvider>
		)
	}
}

export default Affiliate
